import React from "react";
import { Box, MenuItem } from "@mui/material";
import CustomTextField from "./CustomTextField";

const ArticuloSelector = ({ articuloActual, articulosDisponibles, articulosSeleccionados, onSeleccionarArticulo, loading = false }) => {
  return (
    <Box width={310} mb={2}>
      <CustomTextField
        label={articuloActual?.descripcion ? "ARTÍCULO" : "Seleccione un artículo"}
        value={articuloActual?.idArticulo || ""}
        select
        variant="outlined"
        onChange={e => onSeleccionarArticulo(Number(e.target.value))}
        disabled={loading}
        loading={loading}
        sx={{
          mb: 2,
          "& .MuiFormLabel-root": {
            fontSize: "1rem",
            color: "#000",
          },
        }}
      >
        {articulosDisponibles.map(a => (
          <MenuItem key={a.idArticulo} value={a.idArticulo} disabled={articulosSeleccionados.includes(a.idArticulo)}>
            {a.descripcion}
          </MenuItem>
        ))}
      </CustomTextField>

      <CustomTextField label="CÓDIGO ARTÍCULO" value={articuloActual?.codigo || ""} disabled loading={loading} />
    </Box>
  );
};

export default ArticuloSelector;
